import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatPercent,
  mergeRow,
  normalizeOtherRows,
  safeText,
  setCell,
} from "./principle5SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of other value chain";

const SHEET_TITLE = "Details of other assessments of value chain partner";

export function buildDetailsOfOtherValueChainSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 28;
  ws.getColumn("F").width = 36;

  const leadership = sectionC?.principle5?.leadershipIndicator || {};
  const rows = normalizeOtherRows(leadership?.other);
  const dataRows = rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_5, { mergeEnd: COL_F });

  mergeRow(ws, TITLE_ROW, COL_D, COL_F, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name of other assessment", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(
    ws,
    HEADER_ROW,
    COL_F,
    "% of value chain partners (by value of business done with such partners) that were assessed",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.name), { align: "left" });
    setCell(ws, row, COL_F, formatPercent(item?.percentage), { align: "center" });
  });

  return ws;
}
